import { useAuthentication } from 'src/features/authentication/context';
import { Protected } from 'src/features/protected-route/components';
import { AppLayout } from 'src/layouts';
import { AddCustomerAccountPage } from '../../pages';
import { ACCOUNT_ISSUE_PATH, ADD_CUSTOMER_ACCOUNT_HEADER, LOGIN_PATH } from '../../config';
import { NAV_ITEMS_HEADER_HOME_PAGE } from 'src/features';
import { ElementProps } from '../../types/element';
import { LoadingElement } from '../LoadingElement';

export const CustomerAddAccountElement = ({ isSuperAdmin }: ElementProps) => {
  const { loggedIn } = useAuthentication();

  const getUniqueRedirectPath = () => {
    if (!loggedIn.value) return LOGIN_PATH;
    if (!isSuperAdmin) return ACCOUNT_ISSUE_PATH + '?reason=Access Denied';
  };

  const CustomerAddAccountRouteElement = () => (
    <Protected
      isAuthenticated={loggedIn.value}
      isAuthorized={isSuperAdmin}
      uniqueRedirectPath={getUniqueRedirectPath()}
    >
      <AppLayout
        headerTitle={ADD_CUSTOMER_ACCOUNT_HEADER}
        headerNavItems={NAV_ITEMS_HEADER_HOME_PAGE}
        isCustomerAccountPage={true}
        isSuperAdmin={isSuperAdmin}
      >
        <AddCustomerAccountPage />
      </AppLayout>
    </Protected>
  );

  const getCustomerAddAccountElement = () => {
    if (!loggedIn.loaded) {
      return <LoadingElement />;
    }

    return <CustomerAddAccountRouteElement />;
  };

  return getCustomerAddAccountElement();
};
